import React, { useState } from "react";
import "./achivements.css";
import achievementImg from '../../Assets/achivement.webp';

/* ══════════════════════════════════════
   ADD YOUR ACHIEVEMENTS HERE
   Each entry:  { title, year, description, image, tag }
   image is optional — falls back to achievementImg
   ══════════════════════════════════════ */
const ACHIEVEMENTS = [
  {
    title: "Winner of National Photography Competition",
    year: "2019",
    description:
      "Awarded first place at the National Photography Competition for outstanding work in wedding and event photography, competing against over 2Lakhs+ photographers across India.",
    image: achievementImg,
    tag: "🏆 National Award",
    highlight: true,
  },
  // ── Add more below ──
  // {
  //   title: "Best Wedding Photographer — Gujarat",
  //   year: "2022",
  //   description: "Recognised by the Gujarat Photographers Association for excellence in wedding photography.",
  //   image: achievementImg,
  //   tag: "🥇 State Award",
  // },
];

/* ── MILESTONE STATS ── */
const MILESTONES = [
  { icon: "🏆", value: "1+",   label: "National Awards"   },
  { icon: "📸", value: "9+",  label: "Years of Excellence" },
  { icon: "🎯", value: "100%", label: "Client Satisfaction" },
];

const Achievements = () => {
  const [expanded, setExpanded] = useState(null);

  return (
    <section className="ach-section" id="paper">

      {/* ── HEADER ── */}
      <div className="ach-header">
        <span className="ach-eyebrow">Recognition</span>
        <h2 className="ach-title">Achievements</h2>
        <div className="ach-ornament">
          <span />
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#C9A84C">
            <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4z"/>
          </svg>
          <span />
        </div>
        <p className="ach-subtitle">
          Recognised for excellence in photography &amp; cinematography across India.
        </p>
      </div>

      {/* ── MILESTONE STRIP ── */}
      <div className="ach-milestones">
        {MILESTONES.map(({ icon, value, label }) => (
          <div key={label} className="ach-milestone">
            <span className="ach-milestone-icon">{icon}</span>
            <span className="ach-milestone-value">{value}</span>
            <span className="ach-milestone-label">{label}</span>
          </div>
        ))}
      </div>

      {/* ── AWARD CARDS ── */}
      <div className="ach-cards">
        {ACHIEVEMENTS.map((item, i) => (
          <div
            key={i}
            className={`ach-card ${item.highlight ? 'ach-card--highlight' : ''} ${expanded === i ? 'ach-card--open' : ''}`}
          >
            {/* Left — image */}
            <div className="ach-card-img-wrap">
              <img
                src={item.image}
                alt={item.title}
                className="ach-card-img"
                loading="lazy"
              />
              <div className="ach-card-img-overlay" />
              {/* Year ribbon */}
              <div className="ach-year-ribbon">
                <span>{item.year}</span>
              </div>
            </div>

            {/* Right — content */}
            <div className="ach-card-body">
              {item.tag && <span className="ach-tag">{item.tag}</span>}

              <h3 className="ach-card-title">{item.title}</h3>

              <div className={`ach-card-desc ${expanded === i ? 'ach-card-desc--open' : ''}`}>
                <p>{item.description}</p>
              </div>

              <button
                className="ach-expand-btn"
                onClick={() => setExpanded(expanded === i ? null : i)}
                aria-expanded={expanded === i}
              >
                {expanded === i ? 'Show Less ↑' : 'Read More ↓'}
              </button>

              {/* Decorative trophy */}
              <div className="ach-card-trophy" aria-hidden="true">🏆</div>
            </div>
          </div>
        ))}
      </div>

      {/* ── EMPTY STATE (if no achievements) ── */}
      {ACHIEVEMENTS.length === 0 && (
        <div className="ach-empty">
          <span>🏅</span>
          <p>Awards &amp; recognitions coming soon.</p>
        </div>
      )}

      {/* ── BOTTOM QUOTE ── */}
      <div className="ach-quote-wrap">
        <blockquote className="ach-quote">
          <span className="ach-quote-mark">"</span>
          Excellence is not a destination but a continuous journey that never ends.
          <span className="ach-quote-mark">"</span>
        </blockquote>
        <p className="ach-quote-attr">— Dhavan Gadiwala, Founder</p>
      </div>

    </section>
  );
};

export default Achievements;